import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { galleyImageOptions } from './views/galley'

class X46Galley extends Component {
    constructor(props) {
        super(props);
        this.handleGalleyChange = this.handleGalleyChange.bind(this);
    }


    handleGalleyChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Worktop = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = galleyImageOptions;

        let image = <ConfiguratorImage boat="X4_6" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='GALLEY' /></h1>

                    <MaterialSelector label={this.props.configuration.Worktop.label} options={this.props.worktopOptions} value={this.props.configuration.Worktop} onChange={this.handleGalleyChange} />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X46Galley);


// WEBPACK FOOTER //
// ./src/X46/X46Galley.js